// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"34648bb1ebfd325ec53b","293":"6af956dddf422ca463f0","522":"fe096ee635d100474a9f"}[chunkId] + ".js";
};